<template>
  <div class="mt-6">
    <v-base-button
      :loading="loading"
      class="btn-white w-full shadow"
      @click="removeFromFavorite($event)"
    >
      <span>
        Remove from favorites
      </span>
    </v-base-button>
  </div>
</template>
<script>
import baseButton from "@/plugins/core/BaseButton.vue";
export default {
  components: {
    "v-base-button": baseButton,
  },
  props: {
    cluster: {
      type: Object,
      required: true
    }
  },
  emits: ["success"],
  data() {
    return {
      loading: false
    };
  },
  methods: {
    removeFromFavorite(event) {
      event.preventDefault();
      this.loading = true;
      this.$http.post(this.$laravel.route("api.clusters.favorites.remove",{cluster:this.cluster.id})).then(
        (response) => {
          this.$notificator.success(response.data.message);
        }
      ).finally(
        () => {
          this.loading = false;
          this.$emit("success");
        }
      );
    }
  }
};
</script>
